<script>
  import Router from "svelte-spa-router"; // Corrected import
  import Main from "./Main.svelte";
  import Signup from "./Signup.svelte";
  import ResetPassword from "./ResetPassword.svelte";
  import ResetPassword_Confirm from "./ResetPassword_Confirm.svelte";

  const routes = {
    "/": Main,
    "/login": Main,
    "/newaccount": Signup,
    "/reset-password": ResetPassword,
    "/reset-password/verify": ResetPassword_Confirm,
  };
</script>

<main>
  <Router {routes} />
</main>
